(function () {
    'use strict';

    angular.module('modules.cookie_banner.pages', []);
})();
